import React, { createContext, useState, useContext } from 'react';

const LastVisitedContext = createContext();

export const LastVisitedProvider = ({ children }) => {
  const [lastVisited, setLastVisited] = useState(null);

  return (
    <LastVisitedContext.Provider value={{ lastVisited, setLastVisited }}>
      {children}
    </LastVisitedContext.Provider>
  );
};

export const useLastVisited = () => useContext(LastVisitedContext);